import { publicClient, privateClient } from './client';
import { Wishlist } from './Wishlist';

const transactionsWishlist = (pub: boolean) => new Wishlist(pub ? publicClient : privateClient);
export default transactionsWishlist;
